export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list.vue?vue&type=template&id=ad5b388c"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/content/strings/list.vue?vue&type=template&id=ad5b388c
// module id = f0rI
// module chunks = 0